import { axiosObject } from "../config";

function homeLoanInterest(data: any) {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/loan-enquiries/_create";

    axiosObject
      .post(uri, data)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export { homeLoanInterest };
